import React, { Component }            from 'react';
import { Alert, Accordion,
         Card, Button }                from 'react-bootstrap';
import { FaSearch }                    from 'react-icons/fa';
import { LocalForm }                   from 'react-redux-form';
import { ClipLoader }                  from 'react-spinners';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import { isLoggedIn }                  from '../../../../../utils/authService';
import { isInRoleFromToken }           from '../../../../../utils/authService';
import { EmployeeOnboardingConstants } from '../../environment';
import RequestItem                     from './RequestItem';
import { listFetchData }               from '../../../../../actions/employee-onboarding/list';

var apiHost = EmployeeOnboardingConstants.WebApiHost;

class Requests extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      search : '',
      door   : false
    };
    
    this.reload       = this.reload.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.updateDoor   = this.updateDoor.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  
  handleSelect(evt, key) {
    //if (evt === true) {
      this.setState({ activeKey: key });
    //}
    //else {
    //  this.setState({ activeKey: 0 });
    //}
  }
  
  updateSearch(event) {
    this.setState({ search: event.target.value.toLowerCase() });
  }
  
  updateDoor(event) {
    this.setState({ door: event.target.checked }, function() {
      this.reload();
    });
  }
  
  handleSubmit(event) {
    this.reload();
    event.preventDefault();
  }

  reload() {
    this.props.fetchData(apiHost, 
    {
      search: this.state.search, 
      door: this.state.door 
    });
  }

  componentDidMount() {
    this.reload();
  }

  render() {
    let content = null;
    let search  = 
      <LocalForm>
        <div style={{float: 'right'}}>
          <label>
            <input type='text' name='search' onChange={evt => this.updateSearch(evt)} />
          </label>
          <button onClick={this.handleSubmit}><FaSearch style={{ marginLeft: '5px', marginTop: '5px' }} /></button>
        </div>
        <div style={{float: 'right'}}>
          <label>
            Include Door Requests
            <input checked={this.state.door} style={{margin: '3px'}} name={'include-door-requests'} type='checkbox' onChange={this.updateDoor.bind(this)} />
          </label>
        </div>
      </LocalForm>;
      
    var items = [];
    for (let i = 0; i < this.props.list.length; i++) {
      var item = this.props.list[i];
      let header = 
          <div>
            {item.SR.toUpperCase()} -
            Requestor - {item.RequestorName}
          </div>;
        
      var expanded = this.state.activeKey === (i+1) ? true : false;
      items.push(   
        <Card key={i}>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" onClick={(evt) => this.handleSelect(evt, i+1)} eventKey={i}>
              {header}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey={i}>
            <Card.Body>
              <RequestItem item={item} eventKey={i} key={item.SR} expanded={expanded} onClick={this.reload.bind(this)} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>   
      );
    }

    if (isLoggedIn() && isInRoleFromToken(EmployeeOnboardingConstants.AdminRole)) {
      if (items.length > 0) {
        content =
          <div>
            {search}   
            <Accordion id='eb-requests' style={{clear: 'both'}}>
              {items}
            </Accordion>
          </div>;
      }
      else if (!this.props.listIsLoading) {
        content =
          <div>    
            {search}          
            <Alert variant="warning" style={{clear: 'both'}}>
              <strong>No Pending Service Requests</strong>
            </Alert>
          </div>;
      }
    }

    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.listIsLoading && isLoggedIn() && isInRoleFromToken(EmployeeOnboardingConstants.AdminRole) ?
            <ClipLoader
              color={'#072659'} 
              loading={this.props.listIsLoading} 
            />
            : <span />
          }
        </div>
        { !this.props.listIsLoading && isLoggedIn() && isInRoleFromToken(EmployeeOnboardingConstants.AdminRole) ?
          <Alert variant="info">
            <strong>The default requests shown are in-progress. To view completed requests, enter a value in the search bar</strong>
          </Alert>
          : <span />
        }
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.employee.list.list,
    listHasErrored: state.employee.list.listHasErrored,
    listIsLoading: state.employee.list.listIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, search) => dispatch(listFetchData(host, search))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Requests));
